module.exports = __webpack_public_path__ + "img/f-1.00e811a4.svg";